import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpsertOnDayPromptMutationVariables = Types.Exact<{
  input: Types.UpsertOnDayPromptInput;
}>;

export type UpsertOnDayPromptMutation = {
  __typename?: 'Mutation';
  upsertOnDayPrompt: {
    __typename?: 'UpsertOnDayPromptResponse';
    message: string;
    success: boolean;
  };
};

export const UpsertOnDayPromptDocument = gql`
  mutation UpsertOnDayPrompt($input: UpsertOnDayPromptInput!) {
    upsertOnDayPrompt(input: $input) {
      message
      success
    }
  }
`;
export type UpsertOnDayPromptMutationFn = Apollo.MutationFunction<
  UpsertOnDayPromptMutation,
  UpsertOnDayPromptMutationVariables
>;
export function useUpsertOnDayPromptMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertOnDayPromptMutation,
    UpsertOnDayPromptMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertOnDayPromptMutation,
    UpsertOnDayPromptMutationVariables
  >(UpsertOnDayPromptDocument, options);
}
export type UpsertOnDayPromptMutationHookResult = ReturnType<
  typeof useUpsertOnDayPromptMutation
>;
export type UpsertOnDayPromptMutationResult =
  Apollo.MutationResult<UpsertOnDayPromptMutation>;
export type UpsertOnDayPromptMutationOptions = Apollo.BaseMutationOptions<
  UpsertOnDayPromptMutation,
  UpsertOnDayPromptMutationVariables
>;
